<template>
  <b-form-group
    :label="label"
    :label-size="size"
  >
    <ValidationProvider
      v-slot="validationContext"
      :name="name"
      :rules="validate"
      :mode="validationMode"
    >
      <b-form-input
        v-model="_value"
        :type="type"
        :name="name"
        :placeholder="placeholder"
        :autocomplete="autocomplete"
        :state="getValidationState(validationContext)"
        :size="size"
      >
      </b-form-input>
      <small v-if="helpText">{{helpText}}</small>
      <b-form-invalid-feedback
        v-if="showErrorMessage"
        :state="validationContext.errors.length === 0"
      >
        {{ validationContext.errors.join('. ') }}
      </b-form-invalid-feedback>
    </ValidationProvider>
  </b-form-group>
</template>

<script>
  export default {
    name: 'InputTextComponent',
    props: {
      name: {
        type: String,
        required: true,
      },
      label: {
        type: String,
        required: false,
        default: ''
      },
      placeholder: {
        type: String,
        required: false,
        default: ''
      },
      validate: {
        type: [String, Object],
        required: false,
        default: ''
      },
      value: {
        type: [String, Number],
        required: true,
      },
      validationMode: {
        type: String,
        required: false,
        default: 'passive'
      },
      type: {
        type: String,
        required: false,
        default: 'text',
      },
      size: {
        type: String,
        required: false,
        default: ''
      },
      autocomplete: {
        type: String,
        required: false,
        default: ''
      },
      showErrorMessage: {
        type: Boolean,
        required: false,
        // eslint-disable-next-line vue/no-boolean-default
        default: true,
      },
      helpText: {
        type: String,
        default: ''
      },
    },
    computed: {
      _value: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('update:value', value.trim())
          this.$emit('input', value.trim())
        }
      }
    },
    methods: {
      getValidationState({ validated, valid = null}) {
        return validated ? valid : null
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>